<h1 class="fs14pd15">Buscar número de teléfono ó contacto</h1>
<span class="p-input-icon-left mb-20 minw-100">
    <i class="pi pi-search"></i>
    <input type="text" pInputText placeholder="Buscar contacto" class="minw-100" />
</span>
<br />
<p-table [value]="contacts" styleClass="p-datatable" [(selection)]="contact3" dataKey="code" responsiveLayout="scroll">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="body" let-contact>
        <tr class="cp">
            <td>
                <img src="assets/user-avatar.png" class="imgSize"><b> <span
                        class="custName">{{contact.name}}</span></b><br /><span
                    class="custNumb">{{contact.number}}</span>
            </td>
        </tr>
    </ng-template>
</p-table>